
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/a/[pid]",
      function () {
        return require("private-next-pages/a/[pid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/a/[pid]"])
      });
    }
  